<template lang="pug">
#confirmar-territorio
    p.m-0.pb-2 {{ mensagemConfirmacao }}

    div(v-if="selecionados && selecionados.length > 0")
        p.pt-2(v-for='territorio in selecionados' )
            b {{ territorio.nome }}
            br
            em(v-if='mostrarLocalidade') {{ territorio.localidade }}
            br
            em(v-if='mostrarRepresentantes') {{ territorio.totalRepresentantes }} {{ territorio.totalRepresentantes <= 1 ? $t('mensagens.laudos.pessoaMinusculo') : $t('mensagens.laudos.pessoasMinusculo') }}

    .botao(slot='footer')
        el-button(type='default', size='small', @click='voltar')
            | {{ $t('mensagens.comuns.cancelar') }}

        el-button(type='primary', size='small', @click='confirmar')
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/services/LaudosService';
import TipoLaudo from '@/constants/TipoLaudo';

export default {
    name: 'ConfirmarTerritorio',
    props: {
        selecionados: {
            type: Array,
            default() {
                return [];
            },
            required: true
        },
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    emits: ['voltar'],

    computed: {
        mensagemConfirmacao() {
            const mensagens = {
                [TipoLaudo.AGRICOLA]: this.$t(
                    'mensagens.laudos.confirmaSolicitacaoLaudoAgricolaParaSeguintesTerritorios'
                ),
                [TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoLaudoAvaliacaoAreaProdutiva'
                ),
                [TipoLaudo.AVALIACAO_SOCIOAMBIENTAL]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoDeLaudoAvaliacaoAmbiental'
                ),
                [TipoLaudo.CARBONO]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoLaudoCarbono'
                ),
                [TipoLaudo.DIAGNOSTICO_AGRICOLA]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoDeLaudoDiagnosticoAgricola'
                ),
                [TipoLaudo.HISTORICO_AGRICOLA]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoDeLaudoHistoricoAgricola'
                ),
                [TipoLaudo.SUPRESSAO_VEGETAL]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoDeLaudoSupressaoVegetal'
                ),
                [TipoLaudo.RELATORIO_TERRITORIAL]: this.$t(
                    'mensagens.laudos.confirmarSolicitacaoDeLaudoRelatorioTerritorial'
                )
            };
            return mensagens[this.tipoLaudo] || '';
        },

        mostrarLocalidade() {
            return this.tipoLaudo === TipoLaudo.SUPRESSAO_VEGETAL;
        },

        mostrarRepresentantes() {
            return this.tipoLaudo === TipoLaudo.SUPRESSAO_VEGETAL;
        }
    },

    methods: {
        voltar() {
            this.$emit('voltar');
        },

        async confirmar() {
            try {
                const territorios = {
                    territoriosIds: this.selecionados.map(
                        selecionado => selecionado.id
                    )
                };

                const { data } = await TerritorioService.solicitacaoLaudo(
                    territorios
                );
                const informacaoLaudos = data.map(territorio => {
                    const representante = territorio.representantes?.[0] || {};
                    return {
                        nomeRepresentante:
                            representante.nomeRazaoSocial || null,
                        cpfCnpjRepresentante: representante.cpfCnpj || null,
                        tipoDocumentoRepresentante: representante.cpfCnpj
                            ? representante.cpfCnpj.length < 11
                                ? 'RUC'
                                : 'CPF_CNPJ'
                            : null,
                        territorioId: territorio.id,
                        tipoLaudoId: this.tipoLaudo
                    };
                });

                await LaudosService.cadastrarLaudos({ informacaoLaudos });

                this.$notify.success({
                    message: this.$t(
                        'mensagens.laudos.solicitacaoRealizadaComSucesso'
                    )
                });
                this.voltar();
            } catch (error) {
                this.$notify.error({
                    message:
                        error.response?.data?.mensagem ||
                        this.$t(
                            'mensagens.laudos.ocorreuUmErroAoBuscarTerritorios'
                        )
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#confirmar-territorio {
    .botao {
        display: flex;
        justify-content: right;
        gap: 10px;
    }
}
</style>
